import { request } from '@umijs/max';

/**
 * Mark user as connected to Twilio
 */
export async function connectTwilioStatus(data?: {
  twilio_device_state?: string;
  metadata?: Record<string, any>;
}) {
  return request('/tenant/twilio/connection/connect', {
    method: 'POST',
    data,
  });
}

/**
 * Send heartbeat to indicate user is still connected
 */
export async function sendTwilioHeartbeat(data?: {
  twilio_device_state?: string;
  metadata?: Record<string, any>;
}) {
  return request('/tenant/twilio/connection/heartbeat', {
    method: 'POST',
    data,
  });
}

/**
 * Mark user as disconnected from Twilio
 */
export async function disconnectTwilioStatus(data?: {
  reason?: string;
}) {
  return request('/tenant/twilio/connection/disconnect', {
    method: 'POST',
    data,
  });
}

/**
 * Get current connection status
 */
export async function getTwilioConnectionStatus() {
  return request('/tenant/twilio/connection/status', {
    method: 'GET',
  });
}
